import * as actionTypes from "../../constants/actionTypes";
import { getOfferTypeCount } from "../../api/count";
import { OFFER_TYPES } from "../../constants/offerTypes";

const invalidateOfferTypeCounts = () => {
  return {
    type: actionTypes.INVALIDATE_OFFER_TYPE_COUNTS
  };
};

const loadPhoneOfferCount = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_OFFER_COUNT,
    promise: getOfferTypeCount(clientConfig, OFFER_TYPES.phoneOffer, dataStatus)
  };
};

const loadPropositionCount = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PROPOSITION_COUNT,
    promise: getOfferTypeCount(
      clientConfig,
      OFFER_TYPES.proposition,
      dataStatus
    )
  };
};

const loadSimOnlyCount = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_SIM_ONLY_COUNT,
    promise: getOfferTypeCount(clientConfig, OFFER_TYPES.simOnly, dataStatus)
  };
};

export {
  invalidateOfferTypeCounts,
  loadPhoneOfferCount,
  loadPropositionCount,
  loadSimOnlyCount
};
